import React from 'react';
import { translate } from 'react-i18next';

const EmptyTable = ({ t, colSpan }) => {
  return (
    <tr>
      <td colSpan={colSpan}>
        <div className="alert alert-default text-center mb-0">
          <i className="fa fa-info-circle fa-lg pr-3" />
          {t('info.noResults')}
        </div>
      </td>
    </tr>
  );
};

export default translate()(EmptyTable);



// WEBPACK FOOTER //
// src/modules/common/components/EmptyTable.js